import { Link } from 'react-router-dom';

const FailureNine = () => {


    return (
        <>
        <div className="knowledgetitle">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-lg-6">
                            <div className="page-tit">
                                <h1>knowledge Base</h1>
                            </div>
                        </div>

                        <div className="col-md-12 col-lg-6">
                            <div className="breadcrumb-page">
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li>Pump Failure Modes - Pumps Overheats</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pdf-sec mt-5 mb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="text-center mb-3">Pump Failure Modes - Pumps Overheats</h4>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="pdf-knowledge">
                            <img src='images/knowledge/pump-failure-modes-pumps-overheating.webp' />
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </>
    )
}

export default FailureNine;